import { useRouter } from 'next/router';
import { useLazyQuery } from '@apollo/client';
import { BRAND_PRODUCTS } from 'graphql/queries';
import { useAtomValue } from 'jotai/utils';
import { currentPageAtom } from 'global/store';
import useProductPages from '../products/useProductPages';

export default function useBrandCatalogue() {
  const router = useRouter();
  const lang = router.locale ? router.locale : 'et';
  // Get products
  const currentPage = useAtomValue(currentPageAtom);

  const [getProducts, { data, loading }] = useLazyQuery(BRAND_PRODUCTS, {
    variables: {
      brand: router.query?.id,
      currentPage,
      sortBy: { bestsellers: 'DESC' }
    },
    context: { fetchOptions: { method: 'GET' }, headers: {store: lang} },
    fetchPolicy: 'cache-and-network'
  });

  const { products, pages } = useProductPages(getProducts, data);

  return {
    products,
    loading,
    pages,
    count: data?.products?.total_count
  };
}
